class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// ── Free Shipping Bar Live Update ──
(function () {
  const FREE_SHIPPING_THRESHOLD = 7000; // $70.00 in cents
  let lastCartTotal = null;

  function updateShippingBar(cartTotal) {
    const bar = document.getElementById('sm-shipping-bar');
    if (!bar) return;

    const fill = document.getElementById('sm-shipping-bar-fill');
    const message = bar.querySelector('.sm-shipping-bar__message');
    if (!fill || !message) return;

    const remaining = FREE_SHIPPING_THRESHOLD - cartTotal;
    const progress = Math.min((cartTotal / FREE_SHIPPING_THRESHOLD) * 100, 100);

    // Force reflow before setting width to trigger CSS transition
    fill.style.width = '0%';
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        fill.style.width = progress + '%';
      });
    });

    if (cartTotal >= FREE_SHIPPING_THRESHOLD) {
      fill.classList.add('sm-shipping-bar__fill--complete');
      message.classList.add('sm-shipping-bar__message--unlocked');
      message.innerHTML = "🎉 You've unlocked free shipping!";
    } else {
      fill.classList.remove('sm-shipping-bar__fill--complete');
      message.classList.remove('sm-shipping-bar__message--unlocked');
      const dollars = Math.ceil(remaining / 100);
      message.innerHTML = "You're <strong>$" + dollars + ".00</strong> away from free shipping";
    }
  }

  function fetchAndUpdate() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        if (cart.total_price !== lastCartTotal) {
          lastCartTotal = cart.total_price;
          updateShippingBar(cart.total_price);
        }
      });
  }

  // Run on initial page load
  fetchAndUpdate();

  // Run whenever drawer opens
  document.addEventListener('click', function (e) {
    if (e.target.closest('#cart-icon-bubble') || e.target.closest('[href="/cart"]')) {
      setTimeout(fetchAndUpdate, 100);
    }
  });

  // Run after cart updates (quantity changes, add to cart)
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart) {
      lastCartTotal = e.detail.cart.total_price;
      updateShippingBar(e.detail.cart.total_price);
    } else {
      fetchAndUpdate();
    }
  });

  // Watch for drawer DOM re-renders and re-apply
  const observer = new MutationObserver(function (mutations) {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && node.querySelector && node.querySelector('#sm-shipping-bar-fill')) {
          fetchAndUpdate();
          return;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();